import Vue from 'vue';
import Vuex from 'vuex';
import state from './state';
import * as getters from './getters';
import dashboard from './modules/dashboard';
import customers from './modules/parties/customers';
import users from './modules/users';
import collaborators from './modules/parties/collaborators';
import supervisors from './modules/parties/supervisors';
import technicians from './modules/parties/technicians';
import parties from './modules/parties/parties';
import reports from './modules/reports';
import praTasks from './modules/pra-tasks';
import praTaskRisks from './modules/pra-task-risks';
import praTaskQuestions from './modules/pra-task-questions';
import praTaskRiskPreventions from './modules/pra-task-risk-preventions';
import fileTypes from './modules/fileTypes';
import serviceOrders from './modules/service-order';
import monitoring from './modules/monitoring';
import { baseStore } from 'erp-skeleton-library/base-store/base-store';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    dashboard,
    customers,
    users,
    supervisors,
    technicians,
    parties,
    collaborators,
    reports,
    praTasks,
    praTaskRisks,
    praTaskQuestions,
    praTaskRiskPreventions,
    fileTypes,
    serviceOrders,
    monitoring,
    baseStore,
  },
  state,
  getters,
});

export default store;
